var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { assertIsQueryParam } from './EquipmentServiceDriver';
export class AutomaticMediaRecorderStartTimeBridge {
    constructor(driverState, valueCallback, getKeymap, // videoInputId -> code
    log) {
        this.driverState = driverState;
        this.valueCallback = valueCallback;
        this.getKeymap = getKeymap;
        this.log = log;
        this.name = 'mediaRecorderStartTime';
        this.queryHandlers = {};
        this.setFilters = {};
        this.setHandlers = {};
        this.mediaRecorderStartTimeSubscription = this.driverState.mediaRecorderStartTime.subscribe((key, prev) => {
            var _a;
            const value = this.driverState.mediaRecorderStartTime.values[key];
            const keymap = this.getKeymap();
            const videoInputId = (_a = Object.entries(keymap).find(e => e[1] === key)) === null || _a === void 0 ? void 0 : _a[0];
            if (videoInputId === undefined) {
                this.log.error(`no videoInputId for key ${key}`);
                return;
            }
            this.valueCallback(this.name, { videoInputId, value });
        });
        this.mediaRecorderStateSubscription = this.driverState.mediaRecorderState.subscribe((key, prev) => {
            const curr = this.driverState.mediaRecorderState.values[key];
            const value = curr === 'recording' ? Date.now() : 0;
            this.driverState.mediaRecorderStartTime.update(key, value);
        });
        this.queryHandlers[this.name] = (param) => {
            var _a;
            assertIsQueryParam(param);
            const keymap = this.getKeymap();
            for (const [videoInputId, key] of Object.entries(keymap)) {
                const value = (_a = this.driverState.mediaRecorderStartTime.values[key]) !== null && _a !== void 0 ? _a : 0;
                this.valueCallback(param, { videoInputId, value });
            }
        };
    }
    destroy() {
        this.driverState.mediaRecorderStartTime.unsubscribe(this.mediaRecorderStartTimeSubscription);
        this.driverState.mediaRecorderState.unsubscribe(this.mediaRecorderStateSubscription);
    }
    getInitialValues() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
}
